// extracted by mini-css-extract-plugin
export default {"root":"all-chats_root__wZR62","header_container":"all-chats_header_container__y5fK5"};